import React from 'react'
import styled from 'styled-components'
import { AutoRenewIcon, Flex, Box } from '@pancakeswap/uikit'
import orderBy from 'lodash/orderBy'
import { useTeams } from 'state/teams/hooks'
import Page from 'components/Layout/Page'
import { useTranslation } from 'contexts/Localization'
import TeamListCard from './components/TeamListCard'
import TeamHeader from './components/TeamHeader'
import CommunityHeader from './components/CommunityHeader'

const GridStyle = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaQueries.lg} {
    display: grid;
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    grid-template-columns: 1fr 1fr 1fr;
  }
`
const LogoStyle = styled(Flex)`
  grid-row-start: span 2;
  justify-content: center;
  order: -1;
  ${({ theme }) => theme.mediaQueries.lg} {
    order: 0;
  }
  img {
    width: 348px;
    border-radius: 12px;
    max-height: 351px;
  }
`

const DISCORD_DEBLOX_IO_INVITE = process.env.DISCORD_DEBLOX_IO_INVITE || "https://discord.gg/GcVu3Ekkmd"

const Teams = () => {
  const { t } = useTranslation()
  const teamList = [
    {
      type: 'discord',
      name: t('Discord'),
      logo: '/images/community/discord.png',
      url: DISCORD_DEBLOX_IO_INVITE,
      btnText: t('Join DC Community'),
      description: DISCORD_DEBLOX_IO_INVITE,
      url2: DISCORD_DEBLOX_IO_INVITE,
      description2: t('Sign in to join Premium Group')
    },
    {
      type: 'logo',
      name: 'Logo',
      logo: '/images/community/avatar.png',
    },
    {
      type: 'twitter',
      name: t('Twitter'),
      logo: '/images/community/twitter.png',
      url: 'https://twitter.com/debloxio',
      btnText: t('Follow our Twitter'),
      description: 'https://twitter.com/debloxio'
    },
    {
      type: 'instagram',
      name: t('Instagram'),
      logo: '/images/community/instagram.png',
      url: 'https://www.instagram.com/debloxio/',
      btnText: t('Follow our Instagram'),
      description: 'https://www.instagram.com/debloxio/'
    },
    {
      type: 'telegram',
      name: t('Telegram'),
      logo: '/images/community/telegram.png',
      url: 'https://t.me/deblox',
      btnText: t('Join TG Community'),
      description: 'https://t.me/deblox'
    },
    {
      type: 'telegram',
      name: t('Telegram'),
      logo: '/images/community/telegram.png',
      url: 'https://t.me/debloxcn',
      btnText: t('Join Chinese TG'),
      description: 'https://t.me/debloxcn'
    },
    {
      type: 'telegram',
      name: t('Telegram'),
      logo: '/images/community/telegram.png',
      url: 'https://t.me/DebloxPhilippines',
      btnText: t('Join Philippine TG'),
      description: 'https://t.me/DebloxPhilippines'
    }
  ]

  return (
    <Page>
      <CommunityHeader />
      <GridStyle>
        {
          teamList.map(team => {
            if (team.type === "discord") {
              return (<Box style={{gridColumnStart: 'span 2'}}><TeamListCard {...team} /></Box>)
            }
            if (team.type === "logo") {
              return (
                <LogoStyle>
                  <img src={team.logo} alt="" />
                </LogoStyle>
              )
            }
            return (<Box style={{gridColumnStart: 'span 1', gridRowStart: 'span 1'}}><TeamListCard {...team} /></Box>)
          })
        }
      </GridStyle>
    </Page>
  )
}

export default Teams
